module.exports = __webpack_public_path__ + "img/tp_link.bf75b8dc.svg";